import * as z from 'zod';

export const dependentsSchema = z.object({
  name: z.string(),
  gender: z.string(),
  parentage: z.number(),
  plano: z.number(),
  plano_vl: z.optional(z.string()),
});
